import { authenticatedRequest } from './authApi';
import { REST_API_ORIGIN } from '../platform/endpoints';
const API_BASE = REST_API_ORIGIN;

async function req(path, { method = 'GET', body } = {}) {
  return authenticatedRequest(`${API_BASE}${path}`, { method, body, diagSource: 'contactsApi' });
}



// Conveniencia: usa el token del storage automáticamente
export async function sendRequestAuto(toUserId) {
  return sendRequest(undefined, toUserId);
}

export async function getContacts(token) {
  void token;
  return req('/api/contacts/friends');
}

export async function getPending(token) {
  void token;
  return req('/api/contacts/requests');
}

export async function acceptRequest(token, requestId) {
  void token;
  return req('/api/contacts/respond', {
    method: 'POST',
    body: { requestId, action: 'accept' },
  });
}

export async function rejectRequest(token, requestId) {
  void token;
  return req('/api/contacts/respond', {
    method: 'POST',
    body: { requestId, action: 'decline' },
  });
}

export async function sendRequest(token, toUserId) {
  void token;
  try {
    return await req('/api/contacts/request', {
      method: 'POST',
      body: { toUserId },
    });
  } catch (err) {
    if (err && err.status === 409) {
      // Ya son contactos (o relación existente)
      return { conflict: true, message: err.message || 'Ya son contactos.' };
    }
    throw err; // otros errores sí se propagan
  }
}

export async function removeContact(token, friendId) {
  void token;
  if (!friendId) throw new Error('friendId requerido');
  return req(`/api/contacts/${friendId}`, {
    method: 'DELETE',
  });
}

// Alias legacy
export async function deleteFriend(token, friendId) {
  return removeContact(token, friendId);
}
